import * as React from "react";
import { useEffect, useState } from "react";

import "./checkout.less";
import { ButtonModalViewCart } from "modules/shared/button-view-cart";
import { useAppDispatch, useAppSelector } from "app.hook";

import { shallowEqual, useSelector } from "react-redux";
import { ApplyCouponComponent } from "./components/apply-coupon";
import {
  closeConfirmModal,
  selectSignIn,
  setLoading,
  showConfirmModal,
  showError,
} from "states/global-value/global-value.slice";

import {
  calculateTotal,
  clearShoppingCart,
  clearShoppingCartGuest,
  selectGuestCustomerInfo,
  selectShoppingCart,
  setPickupTime,
  setShoppingCart,
  showViewCartModal,
} from "states/shopping-cart/shopping-cart.slice";
import {
  formatMoney,
  redirectFileLocalUrl,
} from "shared/plugins/string-helper";
import { VIEW_MENU_ROUTE } from "shared/constants/routes";
import { Link } from "react-router-dom";
import { PickupTime } from "./components/pickup-time";
import { SelectBillingAddress } from "./components/select-billing-address";
import { AddBillingAddress } from "./components/add-billing-address";
import {
  fetchCustomerAddresses,
  selectCustomerAddresses,
} from "states/customer-address/customer-address.slice";
import { AddressTypeEnum } from "states/customer-address/customer-address.models";
import { ConfirmModel } from "states/global-value/global-value.models";
import moment from "moment-timezone";
import { momentDateTimeFormat } from "shared/plugins/localization";
import { placeOrderAPI, placeOrderGuestAPI } from "states/order/order.api";
import {
  ICartPromotionOrderModel,
  ICreatedOrderItemModel,
  IOrderShippingAddressModel,
  IPlaceOrderGuestModel,
  IPlaceOrderModel,
  ShippingTypeEnum,
} from "states/order/order.models";
import { PaymentModal } from "./components/payment-modal";
import {
  IconArrowLeft,
  IconPhone,
  IconQuestionMark,
  IconShoppingBag,
  IconTrash,
} from "themes";
import { selectBranchOrderPickupSetting } from "states/branch-order-pickup-setting/order-pickup-setting.slice";
import history from "shared/plugins/history";
import { ApplyCartPromotionComponent } from "./components/apply-cart-promotion";
import { NonCashModal } from "./components/non-cash-modal";
import { GuestCustomerInformation } from "./components/guest-customer-information";
import { last } from "lodash";
import { RootState } from "app.store";
const CheckoutPage = () => {
  const currentShoppingCart = useAppSelector(selectShoppingCart, shallowEqual);
  const currentAddresses = useAppSelector(
    selectCustomerAddresses,
    shallowEqual
  );
  const currentBranch = useAppSelector(
    (state: RootState) => state.shoppingCart.shoppingCart.branch,
    shallowEqual
  );
  const isLogged = useSelector(selectSignIn, shallowEqual);
  const guestCustomerInfo = useAppSelector(selectGuestCustomerInfo, shallowEqual);
  const orderSetting = useAppSelector(selectBranchOrderPickupSetting, shallowEqual);
  const dispatch = useAppDispatch();
  const [paymentModal, setPaymentModal] = useState<boolean>(false);

  const [orderSuccess, setOrderSuccess] = useState<string>("");
  const [nonCashModal, setNonCashModal] = useState<boolean>(false);

  const handleConfirmOrder = async () => {
    dispatch(setLoading(true));
    try {
      if (isLogged) {
        let payload = {
          branchId: currentShoppingCart.branch.id,
          totalAmount: currentShoppingCart.total,
          coupon: {
            code: currentShoppingCart.couponCode,
            gifts: currentShoppingCart.productOfGifts,
          },
          cartPromotions: currentShoppingCart.cartPromotions.map(x => { return { code: x.cartPromotionName, gifts: x.cartPromotionItems } as ICartPromotionOrderModel }),
          tipAmount: currentShoppingCart.tip,
          requestedPickupTime: moment(currentShoppingCart.requestPickUpTime)
            .tz(currentShoppingCart.branch.ianaTimeZone)
            .toDate(),
          shippingType: ShippingTypeEnum.Pickup,
          orderItems: currentShoppingCart.items.map((m) => {
            return {
              productId: m.productId,
              price: m.price,
              quantity: m.quantity,
              modifiers: m.modifiers.map((mo) => {
                return {
                  productId: mo.productId,
                  price: mo.price,
                  quantity: 1,
                } as ICreatedOrderItemModel;
              }),
            } as ICreatedOrderItemModel;
          }),
        } as IPlaceOrderModel;
        let order = await placeOrderAPI(payload);
        setOrderSuccess(order.data.toString());
      } else {
        let payload = {
          branchId: currentShoppingCart.branch.id,
          totalAmount: currentShoppingCart.total,
          coupon: {
            code: currentShoppingCart.couponCode,
            gifts: currentShoppingCart.productOfGifts,
          },
          cartPromotions: currentShoppingCart.cartPromotions.map(x => { return { code: x.cartPromotionName, gifts: x.cartPromotionItems } as ICartPromotionOrderModel }),
          tipAmount: currentShoppingCart.tip,
          requestedPickupTime: moment(currentShoppingCart.requestPickUpTime)
            .tz(currentShoppingCart.branch.ianaTimeZone)
            .toDate(),
          shippingType: ShippingTypeEnum.Pickup,
          orderItems: currentShoppingCart.items.map((m) => {
            return {
              productId: m.productId,
              price: m.price,
              quantity: m.quantity,
              modifiers: m.modifiers.map((mo) => {
                return {
                  productId: mo.productId,
                  price: mo.price,
                  quantity: 1,
                } as ICreatedOrderItemModel;
              }),
            } as ICreatedOrderItemModel;
          }),
          shippingAddress: {
            firstName: guestCustomerInfo.firstName,
            lastName: guestCustomerInfo.lastName,
            phoneNumber: guestCustomerInfo.phoneNumber,
            postalCode: guestCustomerInfo.postalCode
          } as IOrderShippingAddressModel,
          customerEmail: guestCustomerInfo.email
        } as IPlaceOrderGuestModel;
        let order = await placeOrderGuestAPI(payload);
        setOrderSuccess(order.data.toString());
      }
      dispatch(closeConfirmModal());
      dispatch(setLoading(false));
      setPaymentModal(true);
    } catch (err) {
      dispatch(showError(err.response?.data?.error?.message));
      dispatch(setLoading(false));
      dispatch(closeConfirmModal());
    }
  };
  const handleDeleteShopping = async () => {
    dispatch(setLoading(true));
    try {
      if (isLogged) {
        await dispatch(clearShoppingCart());
      } else {
        dispatch(clearShoppingCartGuest());
      }
      dispatch(closeConfirmModal());
      dispatch(setLoading(false));
    } catch (err) {
      dispatch(showError(err.response?.data?.error?.message));
      dispatch(setLoading(false));
      dispatch(closeConfirmModal());
    }
  };
  useEffect(() => {
    if (!orderSetting.active) {
      history.push("/order-website/view-menu");
    }
    if (isLogged) {
      dispatch(fetchCustomerAddresses());
    }
  }, [orderSetting, currentBranch, isLogged])
  useEffect(() => {
    document.title = "View Order Information";

    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }, []);

  return (
    <>
      <section id="order-information-page" className=" p-2 ">
        <div className="section-header mb-3 p-4  rounded-md bg-white flex justify-between content-center items-center">
          <Link to={VIEW_MENU_ROUTE}>
            <IconArrowLeft width={20} />
          </Link>
          <div className="font-semibold text-center text-lg uppercase">
            Order Information
          </div>
          <button
            className="btn--default"
            onClick={() => {
              dispatch(
                showConfirmModal({
                  title: "Warning",
                  message: "Are you sure remove cart?",
                  onYes: () => {
                    handleDeleteShopping();
                  },
                } as ConfirmModel)
              );
            }}
          >
            <IconTrash width={20} />
          </button>
        </div>
        <div className="section-container mb-3  rounded-md bg-white p-4">
          <div className="head flex mb-2 justify-between content-center items-center">
            <div className="name font-semibold text-md uppercase">
              Information
            </div>
          </div>
          <div className="order-info mt-4">
            <div className="head font-semibold  text-sm uppercase">
              Location:
            </div>
            <div className="info">{currentShoppingCart.branch.name}</div>
          </div>
          <div className="order-info mt-4">
            <div className="head font-semibold text-sm uppercase">Pick up</div>
            <div className="info">
              <PickupTime
                value={currentShoppingCart?.requestPickUpTime}
                onChange={(value) => {
                  if (!value) {
                    return;
                  }
                  dispatch(
                    setPickupTime(value)
                  );
                }}
              />
            </div>
          </div>
        </div>
        <div className="section-container mb-3  rounded-md bg-white p-4">
          <div className="head flex justify-between content-center items-center">
            <div className="name border-b font-semibold text-md uppercase">
              My order
            </div>
            <Link
              to={VIEW_MENU_ROUTE}
              className="btn--primary flex px-3 py-1 uppercase"
            >
              <IconShoppingBag width={20} className="mr-1 text-white" /> Add
              item
            </Link>
          </div>
          <div className="order-info py-4">
            {currentShoppingCart?.items?.map((item) => {
              return (
                <div
                  onClick={() => {
                    dispatch(showViewCartModal());
                  }}
                  className="flex content-center items-start mb-4"
                >
                  <div className="avatar-container">
                    <div className="img-container rounded-md">
                      {item.image !== null ? (
                        <img
                          className="object-center rounded-md"
                          src={redirectFileLocalUrl(item.image ?? "")}
                          alt=""
                        />
                      ) : (
                        <div className="flex content-center rounded-md items-center avatar-thumb h-full w-full bg-yellow-50"></div>
                      )}
                    </div>
                  </div>
                  <div className="info w-full">
                    <div className="name ">
                      <span className="text-sm font-semibold uppercase">
                        {item.name} | {formatMoney(item.price, 2, ".", ",", "$")}
                      </span>
                      <div className="modifiers text-xs">
                        {item.modifiers.map((modi) => (
                          <span>{modi.name} | {formatMoney(modi.price * modi.quantity, 2, ".", ",", "$")}</span>
                        ))}
                      </div>
                      <div className="qty">
                        Qty: {item.quantity}
                      </div>
                    </div>
                    <div className="flex justify-between content-center items-center">
                      <div className="text-red text-sm font-semibold uppercase">
                        {formatMoney(calculateTotal(item), 2, ".", ",", "$")}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
          {currentShoppingCart?.requestPickUpTime != undefined && (
            <ApplyCartPromotionComponent
              shoppingCart={currentShoppingCart}
            />
          )}
        </div>
        {isLogged ? (
          <div className="section-container mb-3 rounded-md bg-white p-4">
            <div className="head flex mb-2 justify-between content-center items-center">
              <div className="name font-semibold text-md uppercase">
                Billing Address
              </div>
              <AddBillingAddress />
            </div>
            <div className="order-info mt-4">
              <SelectBillingAddress
                addresses={currentAddresses?.filter(
                  (m) => m.addressType === AddressTypeEnum.Billing
                )}
                value={currentShoppingCart.billingAddressId}
                onChange={(value) => {
                  dispatch(
                    setShoppingCart({
                      ...currentShoppingCart,
                      billingAddressId: value,
                    })
                  );
                }}
              />
            </div>
          </div>
        ) : (
          <GuestCustomerInformation />
        )}
        <div className="section-container mb-3  rounded-md bg-white p-4">
          <div className="head flex justify-between content-center items-center">
            <div className="name border-b font-semibold text-md uppercase">
              Total
            </div>
          </div>
          <div className="more-option pt-4">
            <ApplyCouponComponent shoppingCart={currentShoppingCart} />
            <div className="tip-container ">
              <h2 className="text-md font-semibold uppercase mb-2">Tips</h2>
              <div className="tip-amount flex content-center items-center">
                <input
                  value={
                    currentShoppingCart.tip > 0 ? currentShoppingCart.tip : ``
                  }
                  type="number"
                  onChange={(ev) => {
                    dispatch(
                      setShoppingCart({
                        ...currentShoppingCart,
                        tip: Number(ev.target.value ?? 0),
                      })
                    );
                  }}
                  className="w-full border border-gray-300 p-1"
                  placeholder="Tip"
                />
              </div>
            </div>
          </div>
          <div className="order-info pt-4">
            {PriceComponent("Subtotal", currentShoppingCart.subTotal)}
            {PriceComponent("Discount", -currentShoppingCart.discount)}
            {PriceComponent("Tip", currentShoppingCart.tip)}
            {PriceComponent("Taxes", currentShoppingCart.taxes)}
            {currentShoppingCart.additionalFeeItems.map(m => (
              PriceComponent(m.taxName, m.feeAmount)
            ))}
            {currentShoppingCart.nonCashAdjFee ? (
              <React.Fragment>
                {PriceComponent(
                  "Convenient fee",
                  currentShoppingCart.nonCashAdjFee,
                  false,
                  // false,
                  // () => {
                  //   setNonCashModal(true);
                  // }
                )}
              </React.Fragment>
            ) : (
              <React.Fragment />
            )}
            {PriceComponent("Total", currentShoppingCart.total, true)}
          </div>
        </div>
        <div className="section-footer">
          <button
            onClick={() => {
              if (!currentShoppingCart.requestPickUpTime) {
                dispatch(showError("Please select pickup time"));
                return;
              }
              if (isLogged && !currentShoppingCart.billingAddressId) {
                dispatch(showError("Please select billing address"));
                return;
              }
              if (currentShoppingCart.items?.length === 0) {
                dispatch(showError("Please select item"));
                return;
              }
              dispatch(
                showConfirmModal({
                  title: "Confirm",
                  message: `Are you sure you want to pick up at ${currentShoppingCart.requestPickUpTime
                    ? moment(currentShoppingCart.requestPickUpTime)
                      .tz(currentShoppingCart.branch.ianaTimeZone)
                      .format(momentDateTimeFormat())
                    : ""
                    }?`,
                  onYes: () => {
                    handleConfirmOrder();
                  },
                } as ConfirmModel)
              );
            }}
            className="btn--primary w-full px-8 py-4 uppercase font-semibold"
          >
            proceed to payment
          </button>
        </div>
        <ButtonModalViewCart />
        {currentShoppingCart.nonCashAdjFee > 0 && (
          <NonCashModal
            nonCashAdjRate={currentShoppingCart.branch.nonCashAdjRate}
            open={nonCashModal}
            onClose={() => {
              setNonCashModal(false);
            }}
          />
        )}
        {orderSuccess && orderSuccess !== "" && (
          <PaymentModal
            isModal={paymentModal}
            billingAddressId={Number(currentShoppingCart.billingAddressId)}
            requestPickUpTime={
              currentShoppingCart?.requestPickUpTime !== undefined &&
                currentShoppingCart?.branch?.ianaTimeZone
                ? moment(currentShoppingCart?.requestPickUpTime ?? new Date())
                  .tz(currentShoppingCart.branch?.ianaTimeZone)
                  .toDate()
                : new Date()
            }
            orderId={orderSuccess}
            onSuccess={() => {
              setOrderSuccess("");
            }}
            closeModal={(isResetModal) => {
              if (isResetModal) {
                setOrderSuccess("");
              }
              setPaymentModal(false);
            }}
          />
        )}
      </section>
    </>
  );
};
export default CheckoutPage;


function PriceComponent(
  name: string,
  price: number,
  isTotal?: boolean,
  isNonCash?: boolean,
  onClick?: () => void
) {
  return (
    <div className="text-price flex justify-between content-center items-center mb-1 pb-1 border-b border-gray-100">
      <div
        className={`name flex ${isTotal ? `text-md font-semibold` : `text-sm `} `}
      >
        {name}
        {isNonCash && <IconQuestionMark width={20} onClick={onClick} />}
      </div>
      <div
        className={`price ${isTotal ? `text-md font-semibold` : `text-sm`} `}
      >
        {formatMoney(price, 2, ".", ",", "$")}
      </div>
    </div>
  );
}
